var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 11C3 11 2.67708 10.8729 2.40625 10.6188C2.13542 10.3646 2 10.05 2 9.67502V2.70002C2 2.38336 2.09792 2.10002 2.29375 1.85002C2.48958 1.60002 2.74583 1.44169 3.0625 1.37502L8 0.400024V8.40002L3.2625 9.35002C3.1875 9.36669 3.125 9.40627 3.075 9.46877C3.025 9.53127 3 9.60002 3 9.67502C3 9.76669 3.0375 9.84377 3.1125 9.90627C3.1875 9.96877 3.275 10 3.375 10H9V2.00002H10V11H3.375ZM4.5 8.08752L7 7.60002V1.62502L4.5 2.11252V8.08752ZM3.5 8.28752V2.31252L3.3125 2.35002C3.22083 2.36669 3.14583 2.40627 3.0875 2.46877C3.02917 2.53127 3 2.60836 3 2.70002V8.41252C3.04167 8.39586 3.08542 8.38127 3.13125 8.36877C3.17708 8.35627 3.22083 8.34586 3.2625 8.33752L3.5 8.28752Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationGuide);
export default __webpack_public_path__ + "static/media/reservation_guide.98cd3f57304685bc587a1b4d4e3e0578.svg";
export { ForwardRef as ReactComponent };